import { TIntegration } from '../../../../types/payroll.type';
import { ReactComponent as GustoIcon } from '../../../../static/payroll/ic_gusto.svg';
import { ReactComponent as ADPIcon } from '../../../../static/payroll/ic_adp.svg';
// import { ReactComponent as RipplingIcon } from '../../../../static/payroll/ic_rippling.svg';
// import { ReactComponent as QuickbooksIcon } from '../../../../static/payroll/ic_qb.svg';
import appLogo from '../../../../assets/appLogo.png';
// import sureLogo from '../../../../static/payroll/surePayroll.png';
// import onPay from '../../../../static/payroll/onPay.png';
import { GustoExportTable, GustoTable } from '../../Gusto';
import { MgmExportTable } from '../../MGM/components';

const INTEGRATIONS: Array<TIntegration> = [
  {
    id: 1,
    title: 'Gusto',
    value: 'gusto',
    icon: GustoIcon,
    isSvgIcon: true,
    description: 'gustoDescription',
  },
  // {
  //   id: 1,
  //   title: 'SurePayroll',
  //   value: 'sure',
  //   icon: sureLogo,
  //   description: 'Export your payroll and HR data in a format compatible with SurePayroll, a leading provider of cloud-based payroll and HR services. This integration simplifies the process of transferring data from our platform to SurePayroll, ensuring accuracy and efficiency in managing your workforce.',
  // },
  {
    id: 2,
    title: 'ManageMate',
    value: 'managemate',
    icon: appLogo,
    description: 'mgmDescription',
  },
  // {
  //   id: 2,
  //   title: 'ADP',
  //   value: 'adp',
  //   isSvgIcon: true,
  //   icon: ADPIcon,
  //   description: 'Export your payroll and HR data in a format compatible with ADP, a leading provider of cloud-based payroll and HR services. This integration simplifies the process of transferring data from our platform to ADP, ensuring accuracy and efficiency in managing your workforce.',
  // },
  // {
  //   id: 3,
  //   title: 'Rippling',
  //   value: 'rippling',
  //   isSvgIcon: true,
  //   icon: RipplingIcon,
  //   description: 'Export your payroll and HR data in a format compatible with Rippling, a leading provider of cloud-based payroll and HR services. This integration simplifies the process of transferring data from our platform to Rippling, ensuring accuracy and efficiency in managing your workforce.',
  // },
  // {
  //   id: 4,
  //   title: 'QuickBooks',
  //   value: 'quickbooks',
  //   isSvgIcon: true,
  //   icon: QuickbooksIcon,
  //   description: 'Export your payroll and HR data in a format compatible with QuickBooks Payroll, a leading provider of cloud-based payroll and HR services. This integration simplifies the process of transferring data from our platform to QuickBooks Payroll, ensuring accuracy and efficiency in managing your workforce.',
  // },
  // {
  //   id: 5,
  //   title: 'onpay',
  //   value: 'onpay',
  //   icon: onPay,
  //   description: 'Export your payroll and HR data in a format compatible with OnPay, a leading provider of cloud-based payroll and HR services. This integration simplifies the process of transferring data from our platform to OnPay, ensuring accuracy and efficiency in managing your workforce.',
  // },
];

const INTEGRATIONS_COMPONENTS: { [key: string]: any } = {
  gusto: {
    1: GustoTable,
    2: GustoExportTable,
  },
  managemate: {
    2: MgmExportTable,
  },
};

const INTEGRATIONS_ICONS: { [key: string]: any } = {
  gusto: {
    icon: GustoIcon,
    isSvgIcon: true,
  },
  managemate: {
    icon: appLogo,
    isSvgIcon: false,
  },
  ADP: {
    icon: ADPIcon,
    isSvgIcon: true,
  },
};

const PAYROLL_STEPS = ['selectExportFormat', 'employeeData', 'exportFormat'];

export {
  INTEGRATIONS,
  INTEGRATIONS_COMPONENTS,
  PAYROLL_STEPS,
  INTEGRATIONS_ICONS,
};
